module.exports = __webpack_public_path__ + "media/images/top/package/package-image1-52b2359590a87c1661bd4eecf63d925a.png";